import { defineMessages } from 'react-intl';

export default defineMessages({
  status: {
    id: 'status',
    defaultMessage: 'Status',
  },
  date: {
    id: 'date',
    defaultMessage: 'Date',
  },
  startDate: {
    id: 'startDate',
    defaultMessage: 'Start date',
  },
  endDate: {
    id: 'endDate',
    defaultMessage: 'End date',
  },
  title: {
    id: 'title',
    defaultMessage: 'Title',
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name',
  },
  description: {
    id: 'description',
    defaultMessage: 'Description',
  },
  createDate: {
    id: 'createDate',
    defaultMessage: 'Create date',
  },
  type: {
    id: 'type',
    defaultMessage: 'Type',
  },
  custom: {
    id: 'custom',
    defaultMessage: 'Custom',
  },
  clearAll: {
    id: 'clearAll',
    defaultMessage: 'Clear all',
  },
  owner: {
    id: 'owner',
    defaultMessage: 'Owner',
  },
  eventOwner: {
    id: 'eventOwner',
    defaultMessage: 'Event owner',
  },
  accOwner: {
    id: 'accOwner',
    defaultMessage: 'Account owner',
  },
  toto: {
    id: 'assignee',
    defaultMessage: 'To',
  },
  watchers: {
    id: 'watchers',
    defaultMessage: 'Watchers',
  },
  currentUser: {
    id: 'currentUser',
    defaultMessage: 'Current user',
  },
  unknownUser: {
    id: 'unknownUser',
    defaultMessage: 'Unknown user',
  },
  unknownChannel: {
    id: 'unknownChannel',
    defaultMessage: 'Unknown channel',
  },
  all: {
    id: 'all',
    defaultMessage: 'All',
  },
  es_new: {
    id: 'es_new',
    defaultMessage: 'New',
  },
  es_in_progress: {
    id: 'es_in_progress',
    defaultMessage: 'In progress',
  },
  es_review: {
    id: 'es_review',
    defaultMessage: 'Review',
  },
  es_close: {
    id: 'es_close',
    defaultMessage: 'Done',
  },
  es_reopen: {
    id: 'es_reopen',
    defaultMessage: 'Reopened',
  },
  es_deleted: {
    id: 'es_deleted',
    defaultMessage: 'Deleted',
  },
  calendar: {
    id: 'calendar',
    defaultMessage: 'Calendar',
  },
  accounts_currencies: {
    id: 'accounts_currencies',
    defaultMessage: 'Accounts',
  },
  editors: {
    id: 'editors',
    defaultMessage: 'Editors',
  },
  processes_simulator: {
    id: 'processes_simulator',
    defaultMessage: 'Processes Simulator',
  },
  expert_systems: {
    id: 'expert_systems',
    defaultMessage: 'Expert Systems',
  },
  scripts: {
    id: 'scripts',
    defaultMessage: 'Scripts',
  },
  searchScriptsByName: {
    id: 'searchScriptsByName',
    defaultMessage: 'Search scripts by name',
  },
  data: {
    id: 'data',
    defaultMessage: 'Data',
  },
  dashboard: {
    id: 'dashboard',
    defaultMessage: 'Dashboard',
  },
  dashboards: {
    id: 'dashboards',
    defaultMessage: 'Dashboards',
  },
  accessRules: {
    id: 'accessRules',
    defaultMessage: 'Access Rules',
  },
  mySimulator: {
    id: 'mySimulator',
    defaultMessage: 'My Simulator',
  },
  bin: {
    id: 'bin',
    defaultMessage: 'Bin',
  },
  myCompany: {
    id: 'myCompany',
    defaultMessage: 'My Company',
  },
  user_relations: {
    id: 'user_relations',
    defaultMessage: 'Communications',
  },
  relation_graph: {
    id: 'relation_graph',
    defaultMessage: 'Company Graph',
  },
  actors_graph: {
    id: 'actors_graph',
    defaultMessage: 'Actors Graph',
  },
  files: {
    id: 'files',
    defaultMessage: 'Files',
  },
  download: {
    id: 'download',
    defaultMessage: 'Download',
  },
  templates: {
    id: 'templates',
    defaultMessage: 'Templates',
  },
  graph: {
    id: 'graph',
    defaultMessage: 'Graph',
  },
  tags: {
    id: 'tags',
    defaultMessage: 'Tags',
  },
  theGraph: {
    id: 'theGraph',
    defaultMessage: 'The Graph',
  },
  settings: {
    id: 'settings',
    defaultMessage: 'Settings',
  },
  trash: {
    id: 'trash',
    defaultMessage: 'Trash',
  },
  operations: {
    id: 'operations',
    defaultMessage: 'Operations',
  },
  myToDoTasks: {
    id: 'myToDoTasks',
    defaultMessage: 'Events',
  },
  withoutReaction: {
    id: 'withoutReaction',
    defaultMessage: 'Without reaction',
  },
  allTasks: {
    id: 'allTasks',
    defaultMessage: 'All events',
  },
  createdByMe: {
    id: 'createdByMe',
    defaultMessage: 'Created by me',
  },
  starred: {
    id: 'starred',
    defaultMessage: 'Starred',
  },
  TODO: {
    id: 'TODO',
    defaultMessage: 'To Do',
  },
  overdue: {
    id: 'overdue',
    defaultMessage: 'Overdue',
  },
  starredFiles: {
    id: 'starredFiles',
    defaultMessage: 'Starred',
  },
  updated: {
    id: 'updated',
    defaultMessage: 'Updated',
  },
  created: {
    id: 'created',
    defaultMessage: 'Created',
  },
  update: {
    id: 'update',
    defaultMessage: 'Update',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
  },
  done: {
    id: 'done',
    defaultMessage: 'Done',
  },
  reject: {
    id: 'reject',
    defaultMessage: 'Reject',
  },
  dueDate_nextOneWeek: {
    id: 'dueDate_nextOneWeek',
    defaultMessage: 'Due in next 1 week',
  },
  dueDate_nextThreeDays: {
    id: 'dueDate_nextThreeDays',
    defaultMessage: 'Due in next 3 days',
  },
  dueDate_nextOneDay: {
    id: 'dueDate_nextOneDay',
    defaultMessage: 'Due in next 1 day',
  },
  dueDate_nowOverdue: {
    id: 'dueDate_nowOverdue',
    defaultMessage: 'Now overdue',
  },
  single: {
    id: 'single',
    defaultMessage: 'Single',
  },
  group: {
    id: 'group',
    defaultMessage: 'Group',
  },
  add: {
    id: 'add',
    defaultMessage: 'Add',
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit',
  },
  replace: {
    id: 'replace',
    defaultMessage: 'Replace',
  },
  findUsers: {
    id: 'findUsers',
    defaultMessage: 'Find users',
  },
  edited: {
    id: 'edited',
    defaultMessage: 'Edited',
  },
  to: {
    id: 'to',
    defaultMessage: 'to',
  },
  deleted: {
    id: 'deleted',
    defaultMessage: 'deleted',
  },
  comment: {
    id: 'comment',
    defaultMessage: 'Comment',
  },
  close: {
    id: 'close',
    defaultMessage: 'Close',
  },
  me: {
    id: 'me',
    defaultMessage: 'Me',
  },
  search: {
    id: 'search',
    defaultMessage: 'Search',
  },
  today: {
    id: 'today',
    defaultMessage: 'Today',
  },
  yesterday: {
    id: 'yesterday',
    defaultMessage: 'Yesterday',
  },
  tomorrow: {
    id: 'tomorrow',
    defaultMessage: 'Tomorrow',
  },
  later: {
    id: 'later',
    defaultMessage: 'Later',
  },
  recent: {
    id: 'recent',
    defaultMessage: 'Recent',
  },
  ok: {
    id: 'ok',
    defaultMessage: 'OK',
  },
  by: {
    id: 'by',
    defaultMessage: 'by',
  },
  remind: {
    id: 'remind',
    defaultMessage: 'Remind (under construction)',
  },
  remove: {
    id: 'remove',
    defaultMessage: 'Remove',
  },
  underConstruction: {
    id: 'underConstruction',
    defaultMessage: 'Under construction',
  },
  reactionRate: {
    id: 'reactionRate',
    defaultMessage: 'Reaction rate',
  },
  writeComment: {
    id: 'writeComment',
    defaultMessage: 'Write comment',
  },
  reaction_view: {
    id: 'reaction_view',
    defaultMessage: 'viewed event',
  },
  reaction_sign: {
    id: 'reaction_sign',
    defaultMessage: 'signed',
  },
  reaction_done: {
    id: 'reaction_done',
    defaultMessage: 'done',
  },
  reaction_rating: {
    id: 'reaction_rating',
    defaultMessage: 'rated event',
  },
  reaction_reject: {
    id: 'reaction_reject',
    defaultMessage: 'rejected',
  },
  reaction_script: {
    id: 'reaction_script',
    defaultMessage: 'added script',
  },
  viewer: {
    id: 'viewer',
    defaultMessage: 'Viewer',
  },
  editor: {
    id: 'editor',
    defaultMessage: 'Editor',
  },
  signer: {
    id: 'signer',
    defaultMessage: 'Signer',
  },
  executor: {
    id: 'executor',
    defaultMessage: 'Executor',
  },
  role_view: {
    id: 'role_view',
    defaultMessage: 'Viewer',
  },
  role_modify: {
    id: 'role_modify',
    defaultMessage: 'Editor',
  },
  role_sign: {
    id: 'role_sign',
    defaultMessage: 'Signer',
  },
  role_execute: {
    id: 'role_execute',
    defaultMessage: 'Executor',
  },
  clients: {
    id: 'clients',
    defaultMessage: 'Clients',
  },
  people: {
    id: 'people',
    defaultMessage: 'People',
  },
  domains: {
    id: 'domains',
    defaultMessage: 'Domains',
  },
  companies: {
    id: 'companies',
    defaultMessage: 'Companies',
  },
  continue: {
    id: 'continue',
    defaultMessage: 'Continue',
  },
  logout: {
    id: 'logout',
    defaultMessage: 'Logout',
  },
  suggestedUsers: {
    id: 'suggestedUsers',
    defaultMessage: 'Suggested users',
  },
  goBack: {
    id: 'goBack',
    defaultMessage: 'Go back',
  },
  send: {
    id: 'send',
    defaultMessage: 'Send',
  },
  message: {
    id: 'message',
    defaultMessage: 'Message',
  },
  field_required: {
    id: 'field_required',
    defaultMessage: 'Field required',
  },
  fieldRequired: {
    id: 'fieldRequired',
    defaultMessage: 'Field is required',
  },
  duplicate_name: {
    id: 'duplicate_name',
    defaultMessage: 'This name already exist.',
  },
  min_len_3: {
    id: 'min_len_3',
    defaultMessage: 'Minimum length 3 characters',
  },
  wrong_format: {
    id: 'wrong_format',
    defaultMessage: 'Wrong format',
  },
  valid_email: {
    id: 'valid_email',
    defaultMessage: 'Please enter valid email',
  },
  reply: {
    id: 'reply',
    defaultMessage: 'Reply',
  },
  reactionsNumber: {
    id: 'reactionsNumber',
    defaultMessage: 'Number of reactions in the event',
  },
  ratingNumber: {
    id: 'ratingNumber',
    defaultMessage: 'Rating of the event',
  },
  eventsNumber: {
    id: 'eventsNumber',
    defaultMessage: 'Number of events in the tree',
  },
  eventPrice: {
    id: 'eventPrice',
    defaultMessage: 'Event price',
  },
  signNumber: {
    id: 'signNumber',
    defaultMessage: 'Number of signatures',
  },
  eventRate: {
    id: 'eventRate',
    defaultMessage: 'Event activity rating',
  },
  userRate: {
    id: 'userRate',
    defaultMessage: 'User activity rating',
  },
  copyEventLink: {
    id: 'copyEventLink',
    defaultMessage: 'Copy event link',
  },
  markAsFavorite: {
    id: 'markAsFavorite',
    defaultMessage: 'Mark as favorite',
  },
  contactUs: {
    id: 'contactUs',
    defaultMessage: 'Contact Us',
  },
  general: {
    id: 'general',
    defaultMessage: 'General',
  },
  members: {
    id: 'members',
    defaultMessage: 'Members',
  },
  integrations: {
    id: 'integrations',
    defaultMessage: 'Integrations',
  },
  connect: {
    id: 'connect',
    defaultMessage: 'Connect',
  },
  channels: {
    id: 'channels',
    defaultMessage: 'Channels',
  },
  saveChanges: {
    id: 'saveChanges',
    defaultMessage: 'Save changes',
  },
  justNow: {
    id: 'justNow',
    defaultMessage: 'just now',
  },
  secondsAgo: {
    id: 'secondsAgo',
    defaultMessage: 'seconds ago',
  },
  minuteAgo: {
    id: 'minuteAgo',
    defaultMessage: 'a minute ago',
  },
  minutesAgo: {
    id: 'minutesAgo',
    defaultMessage: 'minutes ago',
  },
  hourAgo: {
    id: 'hourAgo',
    defaultMessage: '1 hour ago',
  },
  hoursAgo: {
    id: 'hoursAgo',
    defaultMessage: 'hours ago',
  },
  yesterday1: {
    id: 'yesterday1',
    defaultMessage: 'yesterday',
  },
  newEvent: {
    id: 'newEvent',
    defaultMessage: 'New event',
  },
  company: {
    id: 'company',
    defaultMessage: 'Company',
  },
  createNewEvent: {
    id: 'createNewEvent',
    defaultMessage: 'New event',
  },
  selectExisting: {
    id: 'selectExisting',
    defaultMessage: 'Select existing',
  },
  r_all: {
    id: 'r_all',
    defaultMessage: 'All',
  },
  r_comment: {
    id: 'r_comment',
    defaultMessage: 'Comments',
  },
  r_view: {
    id: 'r_view',
    defaultMessage: 'Views',
  },
  r_modify: {
    id: 'r_modify',
    defaultMessage: 'Updates',
  },
  r_sign: {
    id: 'r_sign',
    defaultMessage: 'Signatures',
  },
  r_decompose: {
    id: 'r_decompose',
    defaultMessage: 'Decompositions',
  },
  r_done: {
    id: 'r_done',
    defaultMessage: 'Done',
  },
  r_reject: {
    id: 'r_reject',
    defaultMessage: 'Rejections',
  },
  r_rating: {
    id: 'r_rating',
    defaultMessage: 'Ratings',
  },
  r_linkEvents: {
    id: 'r_linkEvents',
    defaultMessage: 'Link events',
  },
  linkedActors: {
    id: 'linkedActors',
    defaultMessage: 'Linked actors',
  },
  linkActor: {
    id: 'linkActor',
    defaultMessage: 'Link actor',
  },
  resources: {
    id: 'resources',
    defaultMessage: 'Resources',
  },
  viewThePresentation: {
    id: 'viewThePresentation',
    defaultMessage:
      'Want to know more about product features? Explore the presentation.',
  },
  import: {
    id: 'import',
    defaultMessage: 'Import',
  },
  export: {
    id: 'export',
    defaultMessage: 'Export',
  },
  credentials: {
    id: 'credentials',
    defaultMessage: 'Credentials',
  },
  createCredential: {
    id: 'createCredential',
    defaultMessage: 'Create credential',
  },
  updateCredential: {
    id: 'updateCredential',
    defaultMessage: 'Update credential',
  },
  read: {
    id: 'read',
    defaultMessage: 'Read',
  },
  delete: {
    id: 'delete',
    defaultMessage: 'Delete',
  },
  create: {
    id: 'create',
    defaultMessage: 'Create',
  },
  robot: {
    id: 'robot',
    defaultMessage: 'Robot',
  },
  webhooks: {
    id: 'webhooks',
    defaultMessage: 'Webhooks',
  },
  createWebhook: {
    id: 'createWebhook',
    defaultMessage: 'Create webhook',
  },
  updateWebhook: {
    id: 'updateWebhook',
    defaultMessage: 'Update webhook',
  },
  valid_url: {
    id: 'valid_url',
    defaultMessage: 'Please enter valid URL',
  },
  readOnly: {
    id: 'readOnly',
    defaultMessage: 'Read only',
  },
  interfaces: {
    id: 'interfaces',
    defaultMessage: 'Interfaces',
  },
  createNewForm: {
    id: 'createNewForm',
    defaultMessage: 'Create a new form',
  },
  noForms1: {
    id: 'noForms1',
    defaultMessage: 'No templates where found to match your search',
  },
  noForms2: {
    id: 'noForms2',
    defaultMessage: 'Try modifying your search criteria',
  },
  noResults: {
    id: 'noResults',
    defaultMessage: 'Try modifying your search criteria',
  },
  backToPrevStep: {
    id: 'backToPrevStep',
    defaultMessage: 'Back to previous step',
  },
  form: {
    id: 'form',
    defaultMessage: 'Form',
  },
  yes: {
    id: 'yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'no',
    defaultMessage: 'No',
  },
  notifications: {
    id: 'notifications',
    defaultMessage: 'Notifications',
  },
  info: {
    id: 'info',
    defaultMessage: 'Information',
  },
  processes: {
    id: 'processes',
    defaultMessage: 'Processes',
  },
  history: {
    id: 'history',
    defaultMessage: 'History',
  },
  comHistory: {
    id: 'comHistory',
    defaultMessage: 'Communications',
  },
  economics: {
    id: 'economics',
    defaultMessage: 'Economics',
  },
  products: {
    id: 'products',
    defaultMessage: 'Products/Services',
  },
  price: {
    id: 'price',
    defaultMessage: 'Price',
  },
  currency: {
    id: 'currency',
    defaultMessage: 'Currency',
  },
  accName: {
    id: 'accName',
    defaultMessage: 'Account name',
  },
  bp_one_time_pay: {
    id: 'bp_one_time_pay',
    defaultMessage: 'One time pay',
  },
  bp_day: {
    id: 'bp_day',
    defaultMessage: 'Daily',
  },
  bp_week: {
    id: 'bp_week',
    defaultMessage: 'Weekly',
  },
  bp_month: {
    id: 'bp_month',
    defaultMessage: 'Monthly',
  },
  bp_year: {
    id: 'bp_year',
    defaultMessage: 'Yearly',
  },
  'bp_3-month': {
    id: 'bp_3-month',
    defaultMessage: 'Every 3 month',
  },
  'bp_4-month': {
    id: 'bp_4-month',
    defaultMessage: 'Every 4 month',
  },
  'bp_6-month': {
    id: 'bp_6-month',
    defaultMessage: 'Every 6 month',
  },
  generalDetails: {
    id: 'generalDetails',
    defaultMessage: 'General details',
  },
  extraData: {
    id: 'extraData',
    defaultMessage: 'Extra data',
  },
  details: {
    id: 'details',
    defaultMessage: 'Details',
  },
  weight: {
    id: 'weight',
    defaultMessage: 'Weight',
  },
  actorId: {
    id: 'actorId',
    defaultMessage: 'Actor ID',
  },
  debit: {
    id: 'debit',
    defaultMessage: 'Debit',
  },
  credit: {
    id: 'credit',
    defaultMessage: 'Credit',
  },
  total: {
    id: 'total',
    defaultMessage: 'Total',
  },
  copyId: {
    id: 'copyId',
    defaultMessage: 'Copy ID',
  },
  defaultIdCopied: {
    id: 'defaultIdCopied',
    defaultMessage: 'ID has been copied',
  },
  actorName: {
    id: 'actorName',
    defaultMessage: 'Actor name',
  },
  system: {
    id: 'system',
    defaultMessage: 'System',
  },
  view: {
    id: 'view',
    defaultMessage: 'View',
  },
  unnamedForm: {
    id: 'unnamedForm',
    defaultMessage: 'Unnamed Form',
  },
  sharedWith: {
    id: 'sharedWith',
    defaultMessage: 'Shared with',
  },
  apply: {
    id: 'apply',
    defaultMessage: 'Apply',
  },
  searchResults: {
    id: 'searchResults',
    defaultMessage: 'Search results',
  },
  suggestions: {
    id: 'suggestions',
    defaultMessage: 'Suggestions',
  },
  layers: {
    id: 'layers',
    defaultMessage: 'Layers',
  },
  actors: {
    id: 'actors',
    defaultMessage: 'Actors',
  },
  actorsBag: {
    id: 'actorsBag',
    defaultMessage: 'Actors bag',
  },
  graphs: {
    id: 'graphs',
    defaultMessage: 'Graphs',
  },
  simulator: {
    id: 'simulator',
    defaultMessage: 'Simulator',
  },
  from: {
    id: 'from',
    defaultMessage: 'From',
  },
  range_custom: {
    id: 'range_custom',
    defaultMessage: 'Custom range',
  },
  range_today: {
    id: 'range_today',
    defaultMessage: 'Today',
  },
  range_yesterday: {
    id: 'range_yesterday',
    defaultMessage: 'Yesterday',
  },
  range_lastWeek: {
    id: 'range_lastWeek',
    defaultMessage: 'Last week',
  },
  range_lastMonth: {
    id: 'range_lastMonth',
    defaultMessage: 'Last month',
  },
  range_previousMonth: {
    id: 'range_previousMonth',
    defaultMessage: 'Previous month',
  },
  delPermanently: {
    id: 'delPermanently',
    defaultMessage: 'Permanently delete',
  },
  layer: {
    id: 'layer',
    defaultMessage: 'Layer',
  },
  createAccount: {
    id: 'createAccount',
    defaultMessage: 'Create account',
  },
  flagActor: {
    id: 'flagActor',
    defaultMessage: 'Flag actor',
  },
  removeFlag: {
    id: 'removeFlag',
    defaultMessage: 'Remove flag',
  },
  linkWasCopied: {
    id: 'linkWasCopied',
    defaultMessage: 'Link was copied',
  },
  changeOrder: {
    id: 'changeOrder',
    defaultMessage: 'Change order',
  },
  moveToLayer: {
    id: 'moveToLayer',
    defaultMessage: 'Move to layer',
  },
  copyToLayer: {
    id: 'copyToLayer',
    defaultMessage: 'Copy to layer',
  },
  searchActorPlaceholder: {
    id: 'searchActorPlaceholder',
    defaultMessage: 'Search actor by name',
  },
  lname_apis: {
    id: 'lname_apis',
    defaultMessage: 'APIs',
  },
  lname_bin: {
    id: 'lname_bin',
    defaultMessage: 'Trash',
  },
  lname_Bin: {
    id: 'lname_Bin',
    defaultMessage: 'Trash',
  },
  lname_company: {
    id: 'lname_company',
    defaultMessage: 'Company',
  },
  lname_external: {
    id: 'lname_external',
    defaultMessage: 'External',
  },
  lname_internal: {
    id: 'lname_internal',
    defaultMessage: 'Internal',
  },
  lname_accessRights: {
    id: 'lname_accessRights',
    defaultMessage: 'Access rights',
  },
  lname_graphRules: {
    id: 'lname_graphRules',
    defaultMessage: 'Graph rules',
  },
  lname_accounts: {
    id: 'lname_accounts',
    defaultMessage: 'Accounts',
  },
  lname_processes: {
    id: 'lname_processes',
    defaultMessage: 'Processes',
  },
  lname_dashboards: {
    id: 'lname_dashboards',
    defaultMessage: 'Dashboards',
  },
  lname_economics: {
    id: 'lname_economics',
    defaultMessage: 'Economics',
  },
  lname_market: {
    id: 'lname_market',
    defaultMessage: 'Market',
  },
  lname_vertical: {
    id: 'lname_vertical',
    defaultMessage: 'Vertical',
  },
  lname_scripts: {
    id: 'lname_scripts',
    defaultMessage: 'Scripts',
  },
  lname_expertSystems: {
    id: 'lname_expertSystems',
    defaultMessage: 'Expert systems',
  },
  actorsLayer: {
    id: 'actorsLayer',
    defaultMessage: 'Actors Layer',
  },
  actorLinkCopied: {
    id: 'actorLinkCopied',
    defaultMessage: 'Actor link has been copied',
  },
  accessDenied: {
    id: 'accessDenied',
    defaultMessage: 'Access denied',
  },
  layerDetails: {
    id: 'layerDetails',
    defaultMessage: 'layer details',
  },
  openLayer: {
    id: 'openLayer',
    defaultMessage: 'Open layer',
  },
  createLayer: {
    id: 'createLayer',
    defaultMessage: 'Create new layer',
  },
  newLayer: {
    id: 'newLayer',
    defaultMessage: 'New Layer',
  },
  addExistingLayer: {
    id: 'addExistingLayer',
    defaultMessage: 'Add layer',
  },
  shareWith: {
    id: 'shareWith',
    defaultMessage: 'Share with',
  },
  collapse: {
    id: 'collapse',
    defaultMessage: 'Collapse',
  },
  or: {
    id: 'or',
    defaultMessage: 'OR',
  },
  rename: {
    id: 'rename',
    defaultMessage: 'Rename',
  },
  shared: {
    id: 'shared',
    defaultMessage: 'Shared',
  },
  tree: {
    id: 'tree',
    defaultMessage: 'Tree',
  },
  market: {
    id: 'market',
    defaultMessage: 'Market',
  },
  yesDelete: {
    id: 'yesDelete',
    defaultMessage: 'Yes, delete',
  },
  lastUpdated: {
    id: 'lastUpdated',
    defaultMessage: 'Last updated',
  },
  formulaErr0: {
    id: 'formulaErr0',
    defaultMessage: 'Account not found.',
  },
  formulaErr1: {
    id: 'formulaErr1',
    defaultMessage:
      'Account formula has circular dependency. Please check the accounts tree.',
  },
  formulaErr2: {
    id: 'formulaErr2',
    defaultMessage: 'Account formula has circular dependency.',
  },
  formulaErr3: {
    id: 'formulaErr3',
    defaultMessage: 'The result of a formula is not a number.',
  },
  formulaErr4: {
    id: 'formulaErr4',
    defaultMessage: 'Error in formula: ',
  },
  advancedOptions: {
    id: 'advancedOptions',
    defaultMessage: 'Advanced options',
  },
  share: {
    id: 'share',
    defaultMessage: 'Share',
  },
  expiration: {
    id: 'expiration',
    defaultMessage: 'Expiration',
  },
  exp: {
    id: 'exp',
    defaultMessage: 'Exp.',
  },
  linkCopied: {
    id: 'linkCopied',
    defaultMessage: 'Link was copied',
  },
  tplProperties: {
    id: 'tplProperties',
    defaultMessage: 'Template properties',
  },
});
